import React, { useRef, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

import { useTranslation } from "react-i18next";

const MUIConfirm = ({
  open,
  onClose,
  title,
  content,
  onConfirm /* autoFocusConfirm */,
}) => {
  const confirmButtonRef = useRef(null);
  const { t } = useTranslation();
  useEffect(() => {
    if (open && confirmButtonRef.current) {
      // Defer focusing until the next tick, allowing MUI's Dialog
      // to fully render and its internal focus management to settle.
      setTimeout(() => {
        confirmButtonRef.current.focus();
      }, 0); // 0ms timeout
    }
  }, [open]); // Dependency on 'open' ensures it runs when the dialog opens

  return (
    <Dialog
      disableRestoreFocus
      open={open}
      onClose={onClose}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
    >
      <DialogTitle id="confirmation-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="confirmation-dialog-description">
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("general.cancel")}</Button>
        {/* Focus will be handled in MyAuctions */}
        <Button onClick={onConfirm} color="primary" ref={confirmButtonRef}>
          {t("general.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MUIConfirm;
